<template>
  <div class="bcc-image-list">
      <list-item
        v-for="(item, index) in files" :key="index"
        :item="item"
        :index="index"
        @delete="handleDelete"
      ></list-item>
  </div>
</template>

<script>
import ListItem from './list-item.vue'

export default {
  components: { 'list-item': ListItem },
  name: 'list',
  props: ['files'],
  methods: {
    handleDelete (e) {
      this.$emit('handleDelete', e)
    }
  }
}
</script>
